module.exports = __webpack_public_path__ + "4e388263f471e7002584a6106cab65e6.svg";